import React from 'react'
import { Link } from 'react-router-dom'
import { KpiInfoButton } from './KpiInfoButton'

export interface RecruitmentStatCardProps {
  title: string
  value: string
  footerLabel: string
  description?: string
  hint?: string
  hintHref?: string
  hintState?: Record<string, unknown>
  deltaLabel?: string
  /** When true, delta badge uses positive (green) styling; when false, negative (red). */
  deltaPositive?: boolean
  /** When false, the delta badge is not rendered. */
  showDelta?: boolean
}

export function RecruitmentStatCard({
  title,
  value,
  footerLabel,
  description,
  hint,
  hintHref,
  hintState,
  deltaLabel,
  deltaPositive = true,
  showDelta = true,
}: RecruitmentStatCardProps) {
  return (
    <article
      className="box-border flex min-h-[123px] w-full max-w-full flex-1 min-w-0 flex-col rounded-[6px] border border-border bg-card p-4 text-card-foreground transition-colors duration-200 hover:bg-accent/30"
    >
      <div className="flex items-start justify-between gap-2">
        <h3 className="min-w-0 flex-1 text-[11px] font-medium uppercase leading-tight tracking-[0.06em] text-muted-foreground">
          {title}
        </h3>
        {description ? (
          <div className="shrink-0 self-start">
            <KpiInfoButton description={description} />
          </div>
        ) : null}
      </div>

      <p className="mt-1 text-[22px] font-semibold leading-tight tracking-tight text-foreground">
        {value}
      </p>

      {hint ? (
        hintHref ? (
          <Link
            to={hintHref}
            state={hintState}
            className="mt-1 inline-block text-[10px] leading-snug text-[#0284C7] underline-offset-2 transition-colors hover:text-[#0369A1] hover:underline"
          >
            {hint}
          </Link>
        ) : (
          <p className="mt-1 text-[10px] leading-snug text-muted-foreground">{hint}</p>
        )
      ) : null}

      <div className="mt-auto flex items-end justify-between gap-2 pt-1">
        <span className="text-[11px] leading-tight text-muted-foreground">{footerLabel}</span>
        {showDelta && deltaLabel ? (
          <span
            className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-semibold text-white ${
              deltaPositive ? 'bg-[#22C55E]' : 'bg-[#EF4444]'
            }`}
          >
            {deltaLabel}
          </span>
        ) : null}
      </div>
    </article>
  )
}
